import React from 'react';
import { InputTuKhoa } from 'modules/reception/form-timkiem';
import { Button } from '@blueprintjs/core';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import { Reception, LetterProcessingWorkFlow } from 'api';
import {DropDown} from 'components/tt-forms/common';
import { DatePicker } from 'components/tt-forms/common';

let classNames = require('classnames');

class TimKiemYeuCau extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      tuKhoa: '',
      trangThai: '',
      nguonDon: '',
      phanLoai: '',
      trangThaiList: [],

      tuNgay: '',
      denNgay: '',

      searching: this.props.searching,

      spSearch: false,
      search: false,
      doSearch: false,
      searchLoading: false,
      nguonDonList: this.props.nguonDonList
    };
  }
  componentDidMount() {
    if(this.props.nguonDonList.length == 0) {
      LetterProcessingWorkFlow.actions.getNguonDon.request().then(res => {
        this.props.dispatch({
          type: 'CAPNHAT_DULIEUHETHONG',
          duLieuHeThong: [{
            key: 'nguonDon',
            data: res.data
          }]
        })
      })
    }
    let data = localStorage.getItem('dsycData') ? JSON.parse(localStorage.getItem('dsycData')) : {};
    this.state.tuKhoa = data.tuKhoa || '';
    if (data.advanceSearch) {
      this.state.trangThai = data.trangThai || '';
      this.state.nguonDon = data.nguonDon || '';
      this.state.phanLoai = data.phanLoai || '';
      this.state.tuNgay =  data.tuNgay ? new Date(data.tuNgay) : '';
      this.state.denNgay = data.denNgay ? new Date(data.denNgay) : '';
    }
    this.setState({...this.state});
    this.getTrangThai();
  }

  handleSearch(e) {
    e.preventDefault();

    if (!this.props.advanceSearch) {
      this.setState({
        doSearch: true
      });
      this.props.handleSearch(this.state, e);
    } else {
      if(this.validateSubmitForm()) {
        this.setState({
          doSearch: true
        });
        this.props.handleSearch(this.state, e);
      }
    }

    return;
  }

  validateSubmitForm() {
    let pass = true;
    this.props.validators['formTaoDon'].map(validator => {
      if(pass) {
        pass = validator.validate();
      } else {
        validator.validate();
      }
    });
    return pass;
  }

  componentWillUnmount() {

  }

  cancel(e) {
    this.props.onCancel(e);
  }

  handleChange(name, e) {
    this.setState({
      [name]: e.target.value
    })
  }

  handleChangeData(name, e) {
    this.setState({
      [name]: e.target.value
    });
  }

  getTrangThai() {
    Reception.actions.getTrangThaiYeuCau.request().then(res => {
      if (res.data) {
        this.setState({
          trangThaiList: res.data
        });
      } else {
        this.setState({
          trangThaiList: []
        });
      }
    });
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      searching: nextProps.disabled,
      doSearch: nextProps.search
    });
    if (nextProps.nguonDonList != this.props.nguonDonList) {
      this.setState({
        nguonDonList: nextProps.nguonDonList
      })
    }
  }

  handleChangeDate(name, e) {
    if (e && e._d) {
      this.setState({
        [name]: e._d
      });
    } else {
      this.setState({
        [name]: e
      });
    }
  }

  render() {
    let classes = ['btn-green', 'tt-search'];

    if (this.state.searching) {
      classes.push('btn-disable');

      if (this.state.doSearch) {
        classes.push('btn-loading');
      }
    }

    let btnClasses = classNames(classes);
    // this.state.tableLoading ? (this.state.searching ? "btn-green tt-search btn-loading" : "btn-green tt-search btn-disable") : "btn-green tt-search"
    return (
      <form className="search-form" onSubmit={ this.handleSearch.bind(this) }>
        <div className="rows">
          <div className="col-9 no-gutter">
            <InputTuKhoa onChange={ this.handleChange.bind(this, 'tuKhoa') } value={this.state.tuKhoa} />
            <DatePicker label='Tiếp nhận từ ngày' bindValidator={this} value={this.state.tuNgay} channel="formTaoDon" endDate={ this.state.denNgay } onChange={ this.handleChangeDate.bind(this, 'tuNgay') } />
            <DatePicker label='Đến ngày' bindValidator={this} value={this.state.denNgay} channel="formTaoDon" startDate={ this.state.tuNgay } onChange={ this.handleChangeDate.bind(this, 'denNgay') } />
            <div className="clear-left">
              <DropDown label="Phân loại"
                className="input-group col-25"
                selectedValue={this.state.phanLoai}
                options={this.props.phanLoaiList}
                keyName='giaTri' valueName='ten'
                onChange={ this.handleChangeData.bind(this, 'phanLoai') }
                placeholder />
            </div>
            <DropDown label="Nguồn đơn"
              className="input-group col-25"
              selectedValue={this.state.nguonDon}
              options={this.state.nguonDonList}
              keyName='giaTri' valueName='ten'
              onChange={ this.handleChangeData.bind(this, 'nguonDon') }
              placeholder />
            <DropDown label="Trạng thái"
              className="input-group col-25"
              selectedValue={this.state.trangThai}
              options={this.state.trangThaiList}
              keyName='giaTri' valueName='ten'
              onChange={ this.handleChangeData.bind(this, 'trangThai') }
              placeholder />
          </div>
          <div className="col-3 padding-button">
            <div className="btn-wrap full-input-seacrh">
              <Button className={ btnClasses } text="Tìm kiếm" type="submit" disabled={ this.state.searching ? 'disabled' : '' } />
            </div>
            <div className="input-group full-input-seacrh">
              <Link className={ this.state.tableLoading ? "disable-super-search btn-disable-transparent" : "disable-super-search" }
                onClick={ this.cancel.bind(this) }><i className="tt tt-delete"></i>Hủy tìm kiếm nâng cao</Link>
            </div>
          </div>
        </div>
      </form>
      );
  }
}

TimKiemYeuCau.defaultProps = {
  validators: {},
  handleSearch: function() {
    console.log('Please assign handleSearch() method');
  },

  disabled: false,
  searching: false,
  nguonDonList: []
}

function bindStateToProps(state) {
  return {
    nguonDonList: state.duLieuHeThong.nguonDon,
    phanLoaiList: state.duLieuHeThong.loaiDonThu
  };
}

export default connect(bindStateToProps)(TimKiemYeuCau);



// WEBPACK FOOTER //
// ./src/components/modules/reception-periodical/form-timkiem/TimKiemYeuCau.jsx